import { render, staticRenderFns } from "./Moduleinfo.vue?vue&type=template&id=d46b471e"
import script from "./Moduleinfo.vue?vue&type=script&lang=js"
export * from "./Moduleinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports